// Mutation hooks for Add New Listing
'use client';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';

import { uploadFiles } from '@/slw/shared/api/api.service';
import { UploadFilesPayload } from '@/slw/shared/types/file.type';
import { queryClient } from '@/slw/shared/query-client';

import { createListing, publishListing, updateListing } from './listing.api';
import { LISTING_QUERY_KEY } from './listing.query';
import { MY_LISTINGS_ROOT_QUERY_KEY } from '../my-listings/my-listings.query';

export function useCreateListing() {
  return useMutation({
    mutationFn: createListing,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...MY_LISTINGS_ROOT_QUERY_KEY, LISTING_QUERY_KEY] });
      // toast.success('Listing created successfully');
    },
  });
}

export function useUpdateListing() {
  return useMutation({
    mutationFn: updateListing,
    onSuccess: (data) => {
      // Invalidate all listing queries
      queryClient.invalidateQueries({ queryKey: [...MY_LISTINGS_ROOT_QUERY_KEY, LISTING_QUERY_KEY] });
      // Invalidate specific listing query by url if available
      if (data?.data?.url) {
        queryClient.invalidateQueries({ queryKey: [LISTING_QUERY_KEY, data.data.url] });
      }
      // toast.success('Listing updated successfully');
    },
  });
}

export function useUploadImages() {
  return useMutation({
    mutationFn: (payload: UploadFilesPayload) => uploadFiles(payload),
  });
}

export function usePublishListing() {
  return useMutation({
    mutationFn: publishListing,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...MY_LISTINGS_ROOT_QUERY_KEY, LISTING_QUERY_KEY] });
      toast.success('Listing published successfully');
    },
  });
}
